import React from 'react';
import moment from 'moment';
import 'moment-countdown';
import 'moment-timezone';

export default function CountDownTimer(props) {


  let expiry = props.bootData.expDateTime; // '2021-08-25 20:00:00';
  const [prelabel, setPreLabel] = React.useState( (props.bootData.preLabel) ? props.bootData.preLabel: '');
  const [isExpired, setIsExpired] = React.useState(moment().isSameOrAfter(moment.tz(expiry, "America/new_york")));
  //const [timer, setTimer] = React.useState(moment());
  //const [timerDate, setTimerDate] = React.useState(moment('2021-08-22T11:51:34').tz("america/new_york"));
  
  let iterval = 60000;
  if(props.bootData.showSeconds) {
    iterval = 1000;
  }

  const [duration, setDuration] = React.useState(moment().countdown(moment.tz(expiry, "America/new_york")));  
  if(props.bootData.showSeconds) {
    setInterval(()=>{
      setIsExpired(moment().isSameOrAfter(moment.tz(expiry, "America/new_york")));
      let duration = moment().countdown(moment.tz(expiry, "America/new_york"));
      setDuration(duration);
    },1000);

  } else {
    setInterval(()=>{
      setIsExpired(moment().isSameOrAfter(moment.tz(expiry, "America/new_york")));
      let duration = moment().countdown(moment.tz(expiry, "America/new_york"));
      setDuration(duration);
    },60000);

  }

  let render = () => {
    if(isExpired) {
      duration.days = 0;
      duration.hours = 0;
      duration.seconds = 0;
      duration.minutes = 0;
    } 

    if(props.bootData.showSeconds) {
      return (<div className="durationContainers">
        <span className="preLabel">{prelabel}</span>
        <span className="durationItem">
          <span className="durationValue">{duration.days} </span> 
          <span className="durationLabel">Days </span> 
        </span>
        <span className="durationItem">
          <span className="durationValue">{duration.hours} </span> 
          <span className="durationLabel">Hours </span> 
        </span>
        <span className="durationItem">
          <span className="durationValue">{duration.minutes} </span> 
          <span className="durationLabel">Minutes </span>
        </span>
        <span className="durationItem">
          <span className="durationValue">{duration.seconds} </span> 
          <span className="durationLabel">Seconds </span>
        </span>
      </div>);
    } else {
      return (<div className="durationContainers">
        <span className="preLabel">{prelabel}</span>
        <span className="durationItem">
          <span className="durationValue">{duration.days} </span> 
          <span className="durationLabel">Days </span> 
        </span>
        <span className="durationItem">
          <span className="durationValue">{duration.hours} </span> 
          <span className="durationLabel">Hours </span> 
        </span>
        <span className="durationItem">
          <span className="durationValue">{duration.minutes} </span> 
          <span className="durationLabel">Minutes </span>
        </span>
      </div>);
    }

  }

  return (<span>{render()}</span>);
}



// WEBPACK FOOTER //
// ./src/CountDownTimer/index.js